import { RequiredAsterisk } from "../required-asterisk"

interface FromDropdownProps {
    keyName: string
    label: string
    isRequired?: boolean
    className?: string
    options: { id: number | string, name: string }[]
    value: number | string
    onSelectValue: (e: React.ChangeEvent<HTMLSelectElement>) => void
    onAddBtn?: null | (() => void)
    hideBlankOption?: boolean
    isDisabled?: boolean
}

export const FromDropdown: React.FC<FromDropdownProps> = (
    { keyName, label, isRequired = true, className="", options, value, onSelectValue, onAddBtn, hideBlankOption, isDisabled = false }
) => {
    const mbClassName = className?.includes('end-section')? "mb": ""
    return <>
        <div className={mbClassName}>
            <label htmlFor={keyName}>{label}</label>
            {isRequired && <RequiredAsterisk />}
        </div>
        <select className={className} name={keyName} id={keyName} onChange={onSelectValue} value={value} disabled={isDisabled}>
            {!hideBlankOption && <option value=""></option>}
            {options.map((option) => {
                return <option key={option.id} value={option.id}>{option.name}</option>
            })}
        </select>
        {onAddBtn && <button className={`add-btn ${mbClassName}`} title="Add" onClick={onAddBtn}>+</button>}
        {!onAddBtn && !className?.includes('span-2') && <span className={mbClassName}></span>}
    </>
}
